<div
    class="relative flex flex-col h-full max-h-full bg-white transition-all duration-200 ease-in-out w-full box-border overflow-hidden">
    <div class="flex-1 flex flex-col overflow-auto min-h-0 bg-white box-border">
        <div class="flex flex-col h-full">
            @if(!sourcesPanelService.source()) {
            <div class="flex flex-col items-center justify-center flex-1 p-8">
                <div class="flex flex-col items-center space-y-4 max-w-sm text-center">
                    <div class="relative">
                        <div class="w-16 h-16 bg-zinc-100 rounded-full flex items-center justify-center">
                            <app-icon [type]="'file-search'" [size]="'lg'" [class]="'h-8 w-8 text-zinc-400'"
                                [source]="'lucide'"></app-icon>
                        </div>
                        <div
                            class="absolute -bottom-1 -right-1 w-6 h-6 bg-zinc-200 rounded-full flex items-center justify-center">
                            <div class="w-2 h-2 bg-zinc-400 rounded-full"></div>
                        </div>
                    </div>
                    <div class="space-y-2">
                        <h3 class="text-lg font-medium text-zinc-900">
                            No source available
                        </h3>
                        <p class="text-sm text-zinc-500 leading-relaxed">
                            Source preview will appear here when opened.
                        </p>
                    </div>
                </div>
            </div>
            }
            @else if(showDocumentPreview) {
            <div class="flex flex-col h-full">
                <div class="flex justify-between items-center p-4 border-b border-gray-200 bg-white">
                    <div class="text-sm sm:text-base font-bold truncate flex-1">{{ selectedFileName }}</div>
                    <button (click)="closeDocumentPreview()"
                        class="ml-4 p-2 hover:bg-gray-100 rounded-lg transition-colors">
                        <i class="pi pi-times text-gray-600"></i>
                    </button>
                </div>
                <div class="flex-1 overflow-auto">
                    @if(selectedDocumentFile && selectedDocumentId) {
                    <app-multi-format-preview [documentId]="selectedDocumentId" [file]="selectedDocumentFile"
                        [isResizing]="isResizing" [pageNumber]="currentSource?.page_number || 1">
                    </app-multi-format-preview>
                    }
                    @else if(isLoading) {
                    <div class="flex items-center justify-center h-full">
                        <i class="pi pi-spinner pi-spin text-3xl text-blue-600"></i>
                    </div>
                    }
                    @else {
                    <div class="flex items-center justify-center h-full">
                        <div class="text-gray-500">Failed to load document preview</div>
                    </div>
                    }
                </div>
            </div>
            }
        </div>
    </div>
</div>
